'use client';

import { Button } from '@pickleballinc/react-ui';
import { ReactNode, useEffect, useState } from 'react';

import { getLoginUrl } from '@/utils/helpers/getLoginUrl';

interface LoginToViewOverlayProps {
  children: ReactNode;
}

export const LoginToViewOverlay = ({ children }: LoginToViewOverlayProps) => {
  const [baseURL, setBaseURL] = useState('');

  useEffect(() => {
    setBaseURL(window.location.href);
  }, []);

  return (
    <div className='relative'>
      {children}
      <div className='absolute inset-0 z-10 flex items-center justify-center backdrop-blur-sm'>
        <a href={getLoginUrl(baseURL)} rel='nofollow' aria-label='Link to login or sign up'>
          <Button variant='primary' size='sm' className='bg-experiment'>
            Login or Sign Up
          </Button>
        </a>
      </div>
    </div>
  );
};
